import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export interface IActiveUser {
    day?: number
    ios?: number
    android?: number
}
export const getActiveUser = async (limit: number): Promise<ApiRes<IActiveUser[]>> => {
    return await apiGet(API_URL, `admin/active_user/graph?limit=${limit}`)
}
